<template>
  <div style="display: flex; flex-direction: column; width: 100vw; height: 100vh">
    <NuxtPage style="display: flex; flex-direction: column; width: 100vw; height: 100vh" />
  </div>
</template>

<script setup lang="ts"></script>
